import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Cpu } from 'lucide-react'
import { ModelsScreen } from '@/screens/connect/SCR-040-models'

const flag = z.preprocess(v => v === true || v === 1 || v === '1' || v === 'true', z.boolean())

export const Route = createFileRoute('/_app/connect/models')({
  staticData: { screen: { id: 'SCR-040', title: 'Model registry', group: 'Connect', perm: 'model.manage', order: 9, description: 'The models ESM actually uses for embedding and extraction, where they run, and the registry of models the platform knows.', icon: Cpu } },
  validateSearch: z.object({ all: flag.optional().catch(undefined) }),
  component: ModelsScreen,
})
